const PRODUCTION_HOSTS = new Set(['www.atlasscore.org', 'atlasscore.org']);

/** -- Hostnames where Umami / GA collect pageviews and custom events. */
export function isAnalyticsHost(): boolean {
  if (typeof window === 'undefined') return false;
  return PRODUCTION_HOSTS.has(window.location.hostname);
}
